import React from 'react';
import styles from './APPText.module.scss';

export interface APPProps {
  registeredTradeMark?: boolean;
  plural?: boolean;
  shouldWrap?: boolean;
}

const APPText: React.VFC<APPProps> = ({ shouldWrap = false }) => (
  <span className={shouldWrap ? '' : 'text-nowrap'}>
    ActivePlus Portfolios<sup className={styles.sup}>®</sup>
  </span>
);

export default APPText;
